import { Card, CardContent } from "@components/common/card";
import { cn } from "@pma/utils/helpers";
import useTranslator from "@hooks/use-translator";
import ProjectRoles from "@components/projects/project-financial-roles";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@components/common/tabs";
import UserRolesSettings from "./user-roles-settings";
import { useAuth } from "@pma/stores/auth-store";
import { DictType } from "@pma/types";
import { useLocation, useNavigate } from "react-router-dom";

const RolesSettingsTabs = () => {
  const { translate, locale } = useTranslator();
  const { authConfig, setTabManager } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname;
  const isHebrew = locale === "he";

  const allStateTabs = authConfig?.tabs ?? {};
  const settingsActiveTab = allStateTabs ? allStateTabs["settings"] : undefined;
  const activeTabs: DictType = settingsActiveTab || {
    main: "workspace",
    sub: undefined,
  };

  return (
    <Card className='overflow-x-hidden'>
      <CardContent className='p-2 md:p-4'>
        <Tabs
          defaultValue={"settings-roles"}
          className={cn("relative w-full max-w-[90vw] overflow-x-auto", isHebrew ? "rtl" : "ltr")}
        >
          <TabsList className='flex w-full items-center justify-center rounded-full bg-transparent'>
            <TabsTrigger
              className={cn(
                "gap-1 rounded-none border-primary bg-transparent pt-0 text-xs data-[state=active]:border-b-2 data-[state=active]:bg-transparent data-[state=active]:shadow-none",
                activeTabs?.sub === "members" && "border-b-2",
              )}
              onClick={() => {
                setTabManager({ group: "settings", main: "roles", sub: "members" });
                navigate(pathname);
              }}
              value='members'
            >
              {translate("Members")}
            </TabsTrigger>
            <TabsTrigger
              value='finance'
              className={cn(
                "gap-1 rounded-none border-primary bg-transparent pt-0 text-xs data-[state=active]:border-b-2 data-[state=active]:bg-transparent data-[state=active]:shadow-none",
                activeTabs?.sub === "finance" && "border-b-2",
              )}
              onClick={() => {
                setTabManager({ group: "settings", main: "roles", sub: "finance" });
                navigate(pathname);
              }}
            >
              {translate("Finance")}{" "}
            </TabsTrigger>
          </TabsList>

          <TabsContent forceMount value={"settings-roles"} className={cn("p-0")}>
            {activeTabs?.sub === "members" && <UserRolesSettings />}

            {activeTabs?.sub === "finance" && <ProjectRoles />}

          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default RolesSettingsTabs;
